import {Sidebar, Body, Header} from '../../Components/index';

const homeBody = (
    <div className='App-content'>
        <Header />
        <div className='App-body'>
            <div className='fourth-left-aligned middle-height top-item'>
                Future Blog!!
            </div>
        </div>
    </div>
);
function Blog() {
    return (
        <div className="App">
            { homeBody }
        </div>
    );
}

export default Blog;